module.exports = __webpack_public_path__ + "media/img/frontend_application/subpupgrade-6dd36627219081d5d5b2d75d3d732f30.png";